import { z } from 'zod';

export const docSubmissionSchema = z.object({
  nom: z.string().min(1, 'Le nom ne doit pas être vide').max(250, 'Le nom ne doit pas dépasser 250 caractères'),
  typeDossierId: z.number({ required_error: 'Le type de dossier est requis' }).or(z.literal('')),
  validationDateRequired: z.boolean(),
});
